import { JP_DATE_FORMAT, TIME_FORMAT } from "common/common";
import { COMPARE_TYPES } from "common/constants";
import dayjs from "dayjs";
import moment from "moment";

export function formatDate(date, format = JP_DATE_FORMAT) {
	if (!date) return "";

	const parsedDate = dayjs(date);
	if (!parsedDate.isValid()) return "";

	return parsedDate.format(format);
}

export const compareDate = (a, b, type) => {
	const dateA = dayjs(a);
	const dateB = dayjs(b);

	if (!dateA.isValid() || !dateB.isValid()) {
		return false;
	}

	switch (type) {
		case COMPARE_TYPES.IS_BEFORE:
			return dateA.isBefore(dateB);
		case COMPARE_TYPES.IS_AFTER:
			return dateA.isAfter(dateB);
		case COMPARE_TYPES.IS_SAME:
			return dateA.isSame(dateB);
		case COMPARE_TYPES.IS_SAME_OR_BEFORE:
			return dateA.isBefore(dateB) || dateA.isSame(dateB);
		case COMPARE_TYPES.IS_SAME_OR_AFTER:
			return dateA.isAfter(dateB) || dateA.isSame(dateB);
		case COMPARE_TYPES.IS_NOT_SAME:
			return !dateA.isSame(dateB);
		default:
			return false;
	}
};

export const getValidTime = (hour, minute) => {
	const time = moment(`${hour}:${minute}`, TIME_FORMAT);
	return time.isValid() ? time : undefined;
};

export const isValidHour = (hour) => {
	return Number.isInteger(hour) && hour >= 0 && hour <= 23;
};

export const isValidMinute = (minute) => {
	return Number.isInteger(minute) && minute >= 0 && minute <= 59;
};
